// src/services/ProtectedRoute.tsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

interface ProtectedRouteProps {
  isAuthenticated: boolean | null;
  children: React.ReactNode;
  redirectPath: string;
  role?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ isAuthenticated, children, redirectPath, role }) => {
  const location = useLocation();
  const { subscriptionStatus } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (subscriptionStatus === 'inactive') {
    return <Navigate to="/suscripcion" />;
  }

  const isAccessingAdminPath = [
    '/dashboard', '/configuracion', '/historico', '/categorias', '/marcas', '/proveedores', '/sucursales'
  ].some(path => location.pathname.startsWith(path));

  if (role === 'vendedor' && isAccessingAdminPath) {
    return <Navigate to="/caja-venta" />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
